<mat-card class="report-view-cont">
    <mat-card-content class="adjustResponsiveScroll p-0">
        <app-library-item-header (unpinLibrary)="unpinReport()" (closeLibrary)="closeReport()"
            [title]="'REPORT_VIEW' | translate">
        </app-library-item-header>

        <div class="report-view-body" *ngIf="showContent">
            <ul class="report-list">
                @for (item of visibleReportItems; track item.uniqueId) {
                    <li (click)="selectReport(item.reportName, item.uniqueId);"
                        [ngStyle]="indentStyles[item.level]"
                        [class.selected]="selectedReportUniqueId === item.uniqueId"
                        [class.local-library-item]="isLocalLibraryItem(item.uniqueId)">
                        <span class="report-name">{{ item.reportName | translate }}</span>
                        @if (isLocalLibraryItem(item.uniqueId)) {
                            <button class="delete-btn"
                                    (click)="deleteLocalLibraryGroup(item.reportName, $event)">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        }
                    </li>
                }
            </ul>
        </div>
    </mat-card-content>
</mat-card>